import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  yearFilter: {
    minWidth: 120
  }
})

export default useStyles
